/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/widget_android'
export default icon
